import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'msToMinutes'
})
export class MsToMinutesPipe implements PipeTransform {
  transform(value: number | undefined): string {
    if (!value) return '0 mins';
    
    const minutes = Math.floor(value / (1000 * 60));
    const seconds = Math.floor((value % (1000 * 60)) / 1000);
    
    if (minutes === 0) {
      return `${seconds}s`;
    } else if (seconds === 0) {
      return `${minutes}m`;
    }
    
    return `${minutes}m ${seconds}s`;
  }
}